import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App.tsx';
import { startUpdateWatch } from './app/updates.ts';
import './ui/styles.css';

startUpdateWatch();

const root = document.getElementById('root');
if (!root) throw new Error('Kein Wurzelelement gefunden');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
